import {Getter} from "vuex-class";
import {checkMaxUsersQuota} from "~/modules/quotas/service";
import {Component, Vue} from "vue-property-decorator";
import {isDefined} from "~/lib/helpers/guards";
import {ModalQuotas} from "~/components/modals/modal-quotas";

function pluralize(term, amount){
  return amount > 1 ? `${term}s` : term;
}

type Quota = {
  usage:number;
  max:number;
  isReached: boolean;
  key:string;
};

export function quotasMessage(quota: Quota) {
  switch(quota.key){
    case "maxUsers" :
      return {
        title: `Maximum d'utilisateurs atteint (${quota.max})`,
        message: "Vous avez atteint le seuil d'utilisateurs compris dans votre formule. Pour en ajouter, supprimez des utilisateurs existants ou contactez le support"
      };
  }
  return {title: "Seuil atteint", message: "Contactez le support"};
}

@Component
export class QuotasCheckMixin extends Vue {

  @Getter currentUser;

  protected quotasCheckResult: { isReached: boolean, key: string, usage: number, max: number } = null;
  protected showQuotasModal = false;
  protected isLoadingQuotas = false;

  private resetQuotas() {
    this.showQuotasModal = false;
    this.quotasCheckResult = null;
  }

  async checkMaxUsersQuota() {
    this.isLoadingQuotas = true;
    this.resetQuotas();
    this.quotasCheckResult = await checkMaxUsersQuota(this.currentUser.client);
    this.isLoadingQuotas = false;
    return this.checkResults();
  }

  get areQuotasChecked() {
    return isDefined(this.quotasCheckResult);
  }

  get areQuotasOK() {
    return this.areQuotasChecked && this.quotasCheckResult.isReached === false;
  }

  get quotasKOReason() {
    if (this.quotasCheckResult && this.quotasCheckResult.key) {
      return quotasMessage(this.quotasCheckResult).title;
    }
    return null;
  }

  checkResults(){
    if( ! this.areQuotasOK ) {
      this.showQuotasModal = true;
      return false
    }
    return true;
  }

  renderQuotasModal() {
    if (!this.showQuotasModal) return null;
    const {title, message} = quotasMessage(this.quotasCheckResult);
    return <ModalQuotas title={title} message={message} onClose={() => this.showQuotasModal = false}/>;
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3adf0fca/quotas-mixin.tsx" });